import { Box, Divider, Spinner, Text, Image, Button } from '@chakra-ui/react';
import React from 'react';
import ArrowRightIcon from '../../assets/Icons/arrowRight';
import { AppStoreState, useAppStore } from '../../store';
import { Result } from '../../interfaces/components';
import { useNavigate } from 'react-router-dom';
import { getProjectList } from '../../api/InvestorSearch/search';

interface SearchResultProps {
  searchResults: any;
}

export default function SearchResult(props: SearchResultProps) {
  const navigate = useNavigate();
  console.log('props');
  const { searchResults } = props;
  const loading = useAppStore((state: AppStoreState) => state.loading);
  const setLoading = useAppStore((state: AppStoreState) => state.setLoading);
  const setSearchResults = useAppStore((state: AppStoreState) => state.setSearchResults);
  const searchQuery = useAppStore((state: AppStoreState) => state.searchQuery);
  const itemsPerPage = searchResults && searchResults?.results?.length > 0 && searchResults?.results?.length;
  const totalPages = itemsPerPage && searchResults && searchResults?.total_pages;

  const onViewProjectClick = async (itemId: number) => {
    navigate(`/project/${itemId}`);
  };

  const fetchSearchResults = async (searchQuery: string, page: number) => {
    try {
      setLoading(true);
      const res = await getProjectList(searchQuery, page);
      if (res) {
        setSearchResults(res as any);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log('Error While Fetch All Users ', err);
    }
  };

  const handlePrevPage = () => {
    searchResults?.current_page && fetchSearchResults(searchQuery, searchResults?.current_page - 1);
  };

  const handleNextPage = () => {
    searchResults?.current_page && fetchSearchResults(searchQuery, searchResults?.current_page + 1);
  };

  return (
    <>
      {loading ? (
        <Box marginTop="24px">
          <Spinner />
        </Box>
      ) : (
        <Box width="100%" mt="24px">
          <Text color="#797979" fontSize="14px" fontStyle=" normal" fontWeight="500">
            Your search results...
          </Text>
          {searchResults?.results?.length > 0 &&
            searchResults.results.map((item: Result, index: React.Key | null | undefined) => (
              <>
                <Box
                  mt="16px"
                  h={['145px', '122px']}
                  padding="24px 20px"
                  display="flex"
                  flexDirection="column"
                  gap="10px"
                  borderRadius="16px"
                  border="1px solid rgba(0, 0, 0, 0.10)"
                  background="#FFF"
                  key={index}
                  onClick={() => onViewProjectClick(item?.id)}
                  cursor="pointer"
                >
                  <Box display="flex" alignItems="center" justifyContent="space-between">
                    <Box display="flex" alignItems="center" gap="7px">
                      <Box>
                        <Image
                          src={item.logo}
                          width="36px"
                          height="36px"
                          borderRadius="50%"
                          objectFit="cover"
                          referrerPolicy="no-referrer"
                        />
                      </Box>
                      <Text color="rgba(0, 0, 0, 0.85)" fontSize="18px" fontWeight="600">
                        {item?.name}
                      </Text>
                    </Box>
                    <Box
                      display={['none', 'flex']}
                      gap="6px"
                      alignItems="center"
                      cursor="pointer"
                      onClick={() => onViewProjectClick(item?.id)}
                    >
                      <Text color="#5772FF" fontSize="14px" fontWeight="500">
                        View Project
                      </Text>
                      <ArrowRightIcon />
                    </Box>
                  </Box>
                  <Text color="rgba(0, 0, 0, 0.50)" fontSize={['12px', '14px', ' 16px']} fontWeight={['500', '600']}>
                    Building hardware for cryptography
                  </Text>
                  <Box display={['block', 'none']}>
                    <Divider />
                    <Box
                      display="flex"
                      gap="6px"
                      alignItems="center"
                      cursor="pointer"
                      onClick={() => onViewProjectClick(item?.id)}
                      marginTop="10px"
                      justifyContent="end"
                    >
                      <Text color="#5772FF" fontSize="14px" fontWeight="500">
                        View Project
                      </Text>
                      <ArrowRightIcon />
                    </Box>
                  </Box>
                </Box>
              </>
            ))}
          <Box display="flex" justifyContent="space-between" margin="16px 0px 12px 0px">
            <Button onClick={handlePrevPage} isDisabled={searchResults?.current_page === 1}>
              Previous
            </Button>
            <Text>{`Page ${searchResults?.current_page} of ${totalPages}`}</Text>
            <Button onClick={handleNextPage} isDisabled={searchResults?.current_page === totalPages}>
              Next
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
}
